import React, { useEffect, useState } from "react";
import infoIcon from "../../../../assets/images/Icons/info_icon.svg";
import {
  makeAjax,
  showMessage,
  respStatus,
  url,
  matchValidateVersi,
} from "../../../../helpers/global_helper";
import BetFiftyFiftySuccessPopup from "../../../Popups/BetFiftyFiftySuccessPopup";
import ConfirmBetDeskonPopup from "../../../Popups/ConfirmBetDeskonPopup";
import { useSelector, useDispatch } from "react-redux";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import { withTranslation } from "react-i18next";
import { formatPricewithdecimal, formatPrice } from "../../../NumberFormat";
import ErrorInnerPopup from "../../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../../Popups/ErrorPopup";
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";

const FiftyFiftyVersiWap = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [showTooltip, setShowTooltip] = useState(false);
  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };
  const initialReqData = {
    gameId: gameId,
    gameType: "5050",
    fastbet: true,
    databet_as: "",
    databet_kop: "",
    databet_kepala: "",
    databet_ekor: "",
    allowPartner: "allowPartner",
  };
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const [betPopupValue, setBetPopupValue] = useState([]);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [finalRespData, setFinalRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [angka, setAngka] = useState([]);
  const [reqData, setReqData] = useState(initialReqData);
  const [showCancelledPopup, setShowCancelledPopup] = useState(false);
  const [data, setData] = useState({});
  const [totalValueClick, setTotalValueClick] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const [sentData, setSentData] = useState({
    gameId: gameId,
    gameType: "5050",
    betTogelAuth: "betTogelAuth",
    allowPartner: null,
    dataangka: [],
  });
  const handleChange = (e) => {
    setTotalValueClick(false);
    const { name, value } = e.target;
    setReqData({
      ...reqData,
      [name]: value,
      multiple: betDiscount.showMultiple
    });
  };
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const handleSubmitBtn = () => {
    if (!totalValueClick) {
      if (
        !reqData.databet_as &&
        !reqData.databet_kop &&
        !reqData.databet_kepala &&
        !reqData.databet_ekor
      ) {
        setErrorMessage(props.t("format_input"));
        setShowErrorPopup(true);
        return;
      }
      let matchValidate = matchValidateVersi(gameType, reqData);
      if (matchValidate) {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      }
    }
    makeAjax(url.TOGEL_API.processDataBet, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          return;
        }
        if (response.code !== "validation_error") {
          setReqData(initialReqData);
          response.code
            ? setErrorMessage(props.t(response.code))
            : setErrorMessage(props.t("guess_bet_wrong"));
          setShowErrorPopup(true);
          return;
        }
        setErrorMessage("server error No data find");
        setShowErrorPopup(true);
        return;
      }
      setData(response.data);
      setReqData(initialReqData);
      setShowConfirmationPopup(true);

      let newAngaka = [];
      response.data.dataangka.forEach((item) => {
        const angaka = [item.nomor, item.taruhan, item.status];
        newAngaka.push(angaka);
      });
      const newBet = response.data.dataangka.map((item) => item.nomor);
      setBetPopupValue(newBet);
      setAngka(newAngaka);
    });
  };

  useEffect(() => {
    setSentData({
      ...sentData,
      gameId: gameId,
      dataangka: angka,
    });
  }, [angka]);

  const submitProcessOk = () => {
    if (data.pay > user_balance.coin) {
      setErrorMessage(props.t("insufficient_balance"));
      setShowErrorPopup(true);
      setShowConfirmationPopup(false);
    } else {
      makeAjax(url.TOGEL_API.process5050Shio, sentData).then((response) => {
        if (response.status !== respStatus["SUCCESS"]) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }
          if (response.code !== "validation_error") {
            setErrorMessage(props.t(response.code));
            setShowErrorPopup(true);
            return;
          }
          setErrorMessage("server error No data find");
          setShowErrorPopup(true);
          return;
        }
        setShowConfirmationPopup(false);
        setFinalRespData((prevArray) => [...prevArray, response.data]);
        dispatch(getUserBalance());
        setSuccessPopup(true);
        resetAllData();
      });
    }
  };

  useEffect(() => {
    resetAllData();
  }, [gameId]);

  const resetAllData = () => {
    setTotalCountClick(false);
    setReqData({
      gameId: gameId,
      gameType: "5050",
      fastbet: true,
      databet_as: "",
      databet_kop: "",
      databet_kepala: "",
      databet_ekor: "",
      allowPartner: "allowPartner",
    });
    setSentData({
      gameId: gameId,
      gameType: "5050",
      betTogelAuth: "betTogelAuth",
      allowPartner: null,
      dataangka: [],
    });
    setData({});
  };

  const handleResetBtn = () => {
    setTotalCountClick(false);
    setTotalValueClick(false);
    resetAllData();
  };

  const handleOnCancelBet = () => {
    setShowCancelledPopup(true);
    setShowConfirmationPopup(false);
  };

  const handleTotalValueCheck = () => {
    if (
      !reqData.databet_as &&
      !reqData.databet_kop &&
      !reqData.databet_kepala &&
      !reqData.databet_ekor
    ) {
      setErrorMessage(props.t("format_input"));
      setShowErrorPopup(true);
      return;
    }
    let matchValidate = matchValidateVersi(gameType, reqData);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }

    makeAjax(url.TOGEL_API.processDataBet, reqData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
        if (response.code !== "validation_error") {
          setReqData(initialReqData);
          setErrorMessage(props.t(response.code));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setTotalValueClick(true);
      setData(response.data);
      setTotalCountClick(true);
      let newAngaka = [];
      response.data.dataangka.forEach((item) => {
        const angaka = [item.nomor, item.taruhan, item.status];
        newAngaka.push(angaka);
      });
      const newBet = response.data.dataangka.map((item) => item.nomor);
      setBetPopupValue(newBet);
      setAngka(newAngaka);
    });
  };

  const handleTotalValueCheckOk = () => {
    if (totalCountClick) {
      setShowConfirmationPopup(true);
    }
  };
  const handlePopupClose = () => {
    setFinalRespData([]);
    setSuccessPopup(false);
    setTotalValueClick(false);
    handleResetBtn();
    setBetPopupValue([]);
  };

  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className="rules_container">
            <div>
              <p>{props.t('5050_text')}</p>
              <p>
                Format Tarun: Pilihan1*Pilihan2#10+Pilihan3*
                Pilihan4#10+Pilihan4*Pilihan5#1
              </p>
              <p>Conoth Penulisan: b*k#1+gj*gn#2</p>
              <p>Keteramgan: b(besar),k(kecil),gj(ghjil),gn(genap)</p>
            </div>
            <div className="rules_conversion">
              <p>
                Konversi <br /> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div className="versicontainer_new">
            <p>AS</p>
            <textarea
              rows="7"
              placeholder="b*k#1+gj*gn#2"
              name="databet_as"
              value={reqData.databet_as}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>KOP</p>
            <textarea
              rows="7"
              placeholder="b*k#1+gj*gn#2"
              name="databet_kop"
              value={reqData.databet_kop}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>KEPALA</p>
            <textarea
              rows="7"
              placeholder="b*k#1+gj*gn#2"
              name="databet_kepala"
              value={reqData.databet_kepala}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>EKOR</p>
            <textarea
              rows="7"
              placeholder="b*k#1+gj*gn#2"
              name="databet_ekor"
              value={reqData.databet_ekor}
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              {totalValueClick ? (
                <>
                  <div className="result_left">
                    <p>
                      <span>Total {props.t("line")}</span> :{" "}
                      {data.line ? data.line : "-"}
                    </p>
                    <p>
                      <span>Total {props.t("purchases")}</span> :{" "}
                      {data.tover ? formatPrice(data.tover) : "-"} &nbsp;
                    </p>
                  </div>
                  <div className="result_right">
                    <p>
                      <span>
                        {props.t("total")} {props.t("discount")}
                      </span>
                      :{" "}
                      {data.disc
                        ? formatPricewithdecimal(Number(data.disc).toFixed(2))
                        : "-"}
                    </p>
                    <p>
                      <span>Total {props.t("payment")}</span> :{" "}
                      {data.pay
                        ? formatPricewithdecimal(Number(data.pay).toFixed(2))
                        : "-"}
                    </p>
                  </div>
                </>
              ) : (
                <>
                  <div className="result_left">
                    <p>
                      <span>Total {props.t("line")}</span> :{" "}
                      {data.line ? data.line : "-"}
                    </p>
                    <p>
                      <span>Total {props.t("purchases")}</span> :{" "}
                      {data.tover ? formatPricewithdecimal(data.tover) : "-"}{" "}
                      &nbsp;
                    </p>
                  </div>
                  <div className="result_right">
                    <p>
                      <span>
                        {props.t("total")} {props.t("discount")}
                      </span>
                      : {data.disc ? formatPricewithdecimal(data.disc) : "-"}
                    </p>
                    <p>
                      <span>Total {props.t("payment")}</span> :{" "}
                      {data.pay ? formatPricewithdecimal(data.pay) : "-"}
                    </p>
                  </div>
                </>
              )}

              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">b*k#1+gj*gn#2</span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* button*/}
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={handleTotalValueCheck}>
                  {props.t("count_total")}
                </button>
              </div>
              <div className="button_right">
                <button onClick={handleResetBtn}>{props.t('reset')}</button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              {totalValueClick ? (
                <button onClick={handleTotalValueCheckOk}>{props.t('submit')}</button>
              ) : (
                <button onClick={handleSubmitBtn}>{props.t('submit')}</button>
              )}
            </div>
          </div>
        </>
      )}

      {successPopup && (
        <div className="popup-overlay ">
          <BetFiftyFiftySuccessPopup
            response={finalRespData}
            betValue={betPopupValue}
            onClose={handlePopupClose}
          />
        </div>
      )}
      {showConfirmationPopup && (
        <ConfirmBetDeskonPopup
          onClose={handleOnCancelBet}
          submitProcessOk={submitProcessOk}
        />
      )}
      {showCancelledPopup && (
        <CancelledBetDeskonPopup onClose={() => setShowCancelledPopup(false)} />
      )}
      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup
            message={errMessage}
            onClose={() => setShowErrorPopup(false)}
          />
        </ErrorInnerPopup>
      )}
    </div>
  );
};

export default withTranslation()(FiftyFiftyVersiWap);
